export const SIDE_NAVIGATION_EXPANDED_WIDTH = '17rem';
export const SIDE_NAVIGATION_COLLAPSED_WIDTH = '5rem';
